"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSuiTurnstileState = exports.TurnstileEnabledFeature = exports.SuiTurnstileProvider = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactTurnstile = require("@marsidev/react-turnstile");
var _sendErrorToSentry = require("ErrorBoundary/sendErrorToSentry");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var TURNSTILE_SCRIPT_NOT_LOADED = "Turnstile script not loaded";
var VALIDATION_FAILED_USING_TURNSTILE = "Validation failed using turnstile";
var ERR_CODE_TOKEN_EXPIRED = "cf_token_expired";
var ShowSpinner = function ShowSpinner(flag) {
  var spinner = document.getElementById('spinner') || document.getElementById('ajax-spinner-id');
  if (spinner) {
    spinner.style.display = flag ? 'block' : 'none';
  }
};
;
var TurnstileEnabledFeature;
exports.TurnstileEnabledFeature = TurnstileEnabledFeature;
(function (TurnstileEnabledFeature) {
  TurnstileEnabledFeature["klass_code_login"] = "klass_code_login";
})(TurnstileEnabledFeature || (exports.TurnstileEnabledFeature = TurnstileEnabledFeature = {}));
var SuiTurnstileContext = /*#__PURE__*/_react["default"].createContext({});
var SuiTurnstileProvider = function SuiTurnstileProvider(_ref) {
  var _window, _window$turnstile_ena, _APP_CONFIG, _APP_CONFIG$turnstile, _APP_CONFIG2, _APP_CONFIG2$turnstil;
  var userType = _ref.userType,
    action = _ref.action,
    children = _ref.children,
    featureName = _ref.featureName;
  var ref = _react["default"].useRef();
  var attemptRef = (0, _react.useRef)(0);
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    token = _useState2[0],
    setToken = _useState2[1];
  var securityFlowEnabled = (_window = window) === null || _window === void 0 ? void 0 : (_window$turnstile_ena = _window.turnstile_enabled_features) === null || _window$turnstile_ena === void 0 ? void 0 : _window$turnstile_ena[featureName];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isTurnstileLoading = _useState4[0],
    setTurnstileLoading = _useState4[1];
  (0, _react.useEffect)(function () {
    if (securityFlowEnabled) {
      setTurnstileLoading(true);
    }
    return function () {
      setTurnstileLoading(false);
      ShowSpinner(false);
      window.cfTurnstileToken = null;
    };
  }, []);
  (0, _react.useEffect)(function () {
    ShowSpinner(isTurnstileLoading);
  }, [isTurnstileLoading]);
  var logEvent = function logEvent(msg, errorCode) {
    var eventData = {
      validatedUserType: userType,
      custom_user_type: "unverified_user",
      error_code: errorCode
    };
    var trackingOptions = {
      send_datadump: true,
      send_mixpanel: true,
      send_clevertap: false
    };
    trackEventsForGuests(msg, eventData, trackingOptions);
    (0, _sendErrorToSentry.sendErrorToSentry)(new Error(msg), {
      errorCode: errorCode
    });
  };
  var clearToken = function clearToken() {
    setToken(null);
    window.cfTurnstileToken = null;
  };
  var refreshToken = function refreshToken() {
    if (securityFlowEnabled) {
      if (attemptRef.current < 2) {
        var _ref$current;
        setTurnstileLoading(true);
        ref === null || ref === void 0 ? void 0 : (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.reset();
      }
      attemptRef.current++;
    }
  };
  var refreshOnTokenExpiry = function refreshOnTokenExpiry() {
    var _ref$current2;
    clearToken();
    if ((_ref$current2 = ref.current) !== null && _ref$current2 !== void 0 && _ref$current2.isExpired()) {
      refreshToken();
    }
  };
  var handleTurnstileError = function handleTurnstileError(errorCode) {
    setTurnstileLoading(false);
    refreshOnTokenExpiry();
    logEvent(VALIDATION_FAILED_USING_TURNSTILE, errorCode);
  };
  var handleOnExpire = function handleOnExpire(token) {
    setTurnstileLoading(false);
    refreshOnTokenExpiry();
    logEvent(VALIDATION_FAILED_USING_TURNSTILE, ERR_CODE_TOKEN_EXPIRED);
  };
  var handleTurnstileSuccess = function handleTurnstileSuccess(token) {
    setToken(token);
    window.cfTurnstileToken = token;
    setTurnstileLoading(false);
  };
  return /*#__PURE__*/_react["default"].createElement(SuiTurnstileContext.Provider, {
    value: {
      token: token,
      refreshToken: refreshToken,
      isTurnstileLoading: isTurnstileLoading
    },
    "data-sentry-element": "unknown",
    "data-sentry-component": "SuiTurnstileProvider",
    "data-sentry-source-file": "SuiTurnstile.tsx"
  }, children, securityFlowEnabled && ((_APP_CONFIG = APP_CONFIG) === null || _APP_CONFIG === void 0 ? void 0 : (_APP_CONFIG$turnstile = _APP_CONFIG.turnstile) === null || _APP_CONFIG$turnstile === void 0 ? void 0 : _APP_CONFIG$turnstile.siteKey) && /*#__PURE__*/_react["default"].createElement(_reactTurnstile.Turnstile, {
    ref: ref,
    siteKey: (_APP_CONFIG2 = APP_CONFIG) === null || _APP_CONFIG2 === void 0 ? void 0 : (_APP_CONFIG2$turnstil = _APP_CONFIG2.turnstile) === null || _APP_CONFIG2$turnstil === void 0 ? void 0 : _APP_CONFIG2$turnstil.siteKey,
    onError: handleTurnstileError,
    onExpire: handleOnExpire,
    onSuccess: handleTurnstileSuccess,
    scriptOptions: {
      defer: true,
      onError: function onError() {
        clearToken();
        setTurnstileLoading(false);
        logEvent(TURNSTILE_SCRIPT_NOT_LOADED, "script_load_failed");
      }
    },
    options: {
      action: action,
      theme: 'light'
    }
  }));
};
exports.SuiTurnstileProvider = SuiTurnstileProvider;
var useSuiTurnstileState = function useSuiTurnstileState() {
  var context = (0, _react.useContext)(SuiTurnstileContext);
  if (!context) {
    console.warn("Use useSuiTurnstileState in SuiTurnstileProvider");
  }
  return context;
};
exports.useSuiTurnstileState = useSuiTurnstileState;